import type { TonyteActivity } from '../types';

// Curated Dresden events - 13-17 May 2026
// Generated from functions/scripts/dresden-events.may-13-17-2026.json.

export const DRESDEN_MAY_13_17_EVENTS: TonyteActivity[] = [
  {
    "id": "2026-05-13-various-dresden-locations-54-internationales-dixielandfestival-mittwoch-0",
    "title": "54. Internationales Dixielandfestival – Mittwoch",
    "description": "The 54th International Dixieland Festival continues to roll through Dresden on its mid-week peak. Wednesday is historically one of the festival's most vibrant days — brass bands take over Neumarkt, official stages at the Elbufer reach peak capacity by afternoon, and the city's bars and courtyards fill with the overflow of spontaneous sessions. Whether you catch one of the headliner ensembles or simply follow the sound of a trombone down a side street, the atmosphere is genuinely something you can't manufacture: a whole city tuned to the same frequency, at least for a week.",
    "location": "Dresden City Center, 01067 Dresden, Germany",
    "address": "Dresden City Center, 01067 Dresden, Germany",
    "venueName": "Various venues across Dresden",
    "city": "Dresden",
    "category": "culture",
    "entryType": "official_event",
    "sourceType": "curated_event",
    "hostId": "system",
    "hostName": "Various venues across Dresden",
    "startDate": "2026-05-13",
    "endDate": "2026-05-13",
    "startTime": "11:00",
    "endTime": "23:59",
    "coordinates": {
      "lat": 51.0504,
      "lng": 13.7381
    },
    "coverImageUrl": "https://tonyte.app/event-images/Festival_stage_with_pyrotechnics_202605090203_4.jpeg",
    "coverPhoto": "https://tonyte.app/event-images/Festival_stage_with_pyrotechnics_202605090203_4.jpeg",
    "approved": true,
    "isFree": false,
    "maxParticipants": 0,
    "musicGenres": [],
    "hashtags": [
      "Dixieland",
      "JazzFestival",
      "LiveMusic",
      "Dresden",
      "Tonyte",
      "FestivalVibes",
      "Swing"
    ],
    "tags": [
      "dixieland",
      "jazz-festival",
      "live-music",
      "outdoor",
      "social",
      "street-music",
      "festival",
      "swing",
      "brass"
    ],
    "visibility": "public",
    "createdAt": "2026-05-01T00:00:00.000Z",
    "createdBy": "system"
  },
  {
    "id": "2026-05-13-chemiefabrik-dresden-chemiefabrik-presents-turbostaat-1",
    "title": "Chemiefabrik presents: Turbostaat",
    "description": "Turbostaat return to Chemiefabrik — the only venue in Dresden that makes complete sense for this band. Rough concrete, no pretension, a crowd that means it. The Hamburg post-punk outfit have spent twenty years making albums that sound like the moment before something breaks, and their live show delivers exactly that energy: relentless, honest, and loud enough to make the walls feel it. This is not a festival side-stage appearance. This is a club show, and club shows are where Turbostaat are most themselves. Doors at 19:30. Show starts on time.",
    "location": "Petrikirchstraße 5, 01097 Dresden, Germany",
    "address": "Petrikirchstraße 5, 01097 Dresden, Germany",
    "venueName": "Chemiefabrik Dresden",
    "city": "Dresden",
    "category": "culture",
    "entryType": "official_event",
    "sourceType": "curated_event",
    "hostId": "system",
    "hostName": "Chemiefabrik Dresden",
    "startDate": "2026-05-13",
    "endDate": "2026-05-13",
    "startTime": "20:00",
    "endTime": "23:30",
    "coordinates": {
      "lat": 51.0666,
      "lng": 13.7236
    },
    "coverImageUrl": "https://tonyte.app/event-images/Rock_club_party_crowd_singing_202605090203.jpeg",
    "coverPhoto": "https://tonyte.app/event-images/Rock_club_party_crowd_singing_202605090203.jpeg",
    "approved": true,
    "isFree": false,
    "maxParticipants": 0,
    "musicGenres": [
      "Turbostaat"
    ],
    "hashtags": [
      "Turbostaat",
      "PunkConcert",
      "LiveMusic",
      "Chemiefabrik",
      "Tonyte",
      "IndieRock"
    ],
    "tags": [
      "punk",
      "post-punk",
      "live-music",
      "concert",
      "indie-rock",
      "chemiefabrik",
      "alternative"
    ],
    "visibility": "public",
    "createdAt": "2026-05-01T00:00:00.000Z",
    "createdBy": "system"
  },
  {
    "id": "2026-05-13-groovestation-reggae-night-groovestation-2",
    "title": "Reggae Night – Groovestation",
    "description": "One of Dresden's most consistent weekly nights gets an extended Wednesday edition to coincide with Dixieland Festival week. Groovestation's reggae nights are the real thing — proper sound system, rotating selectors who know their crates, and a dancefloor that builds slowly and stays warm. No gimmicks, no fake-tan crowds, just people who came because the music is good. If the official festival stages have you craving something to wind down with, or wind differently, this is the answer.",
    "location": "Katharinenstraße 11-13, 01099 Dresden, Germany",
    "address": "Katharinenstraße 11-13, 01099 Dresden, Germany",
    "venueName": "GrooveStation",
    "city": "Dresden",
    "category": "nightlife",
    "entryType": "official_event",
    "sourceType": "curated_event",
    "hostId": "system",
    "hostName": "GrooveStation",
    "startDate": "2026-05-13",
    "endDate": "2026-05-13",
    "startTime": "22:00",
    "endTime": "04:00",
    "coordinates": {
      "lat": 51.0666705,
      "lng": 13.7492972
    },
    "coverImageUrl": "https://tonyte.app/event-images/Disco_dance_floor_with_mirror_202605090203_2.jpeg",
    "coverPhoto": "https://tonyte.app/event-images/Disco_dance_floor_with_mirror_202605090203_2.jpeg",
    "approved": true,
    "isFree": false,
    "maxParticipants": 0,
    "musicGenres": [],
    "hashtags": [
      "ReggaeNight",
      "Groovestation",
      "DresdenNightlife",
      "Tonyte",
      "Dub",
      "DanceFloor"
    ],
    "tags": [
      "reggae",
      "dub",
      "sound-system",
      "nightclub",
      "dancefloor",
      "social",
      "groovestation"
    ],
    "visibility": "public",
    "createdAt": "2026-05-01T00:00:00.000Z",
    "createdBy": "system"
  },
  {
    "id": "2026-05-14-various-dresden-locations-54-internationales-dixielandfestival-donnerstag-3",
    "title": "54. Internationales Dixielandfestival – Donnerstag",
    "description": "Thursday at Dixieland is parade day. The big procession moves through the city in the afternoon — dozens of bands from across Europe marching through the Innenstadt while crowds line the pavement and pour out of the cafés to watch. It's a reminder that Dixieland isn't just a music genre, it's a civic tradition in Dresden, one the city takes genuine pride in. By evening the atmosphere transforms: festival bars run late, official stages host headliners, and the Neustadt fills with people looking for the right place to land for the night.",
    "location": "Dresden City Center, 01067 Dresden, Germany",
    "address": "Dresden City Center, 01067 Dresden, Germany",
    "venueName": "Various venues across Dresden",
    "city": "Dresden",
    "category": "culture",
    "entryType": "official_event",
    "sourceType": "curated_event",
    "hostId": "system",
    "hostName": "Various venues across Dresden",
    "startDate": "2026-05-14",
    "endDate": "2026-05-14",
    "startTime": "11:00",
    "endTime": "23:59",
    "coordinates": {
      "lat": 51.0504,
      "lng": 13.7381
    },
    "coverImageUrl": "https://tonyte.app/event-images/Festival_stage_with_pyrotechnics_202605090203_3.jpeg",
    "coverPhoto": "https://tonyte.app/event-images/Festival_stage_with_pyrotechnics_202605090203_3.jpeg",
    "approved": true,
    "isFree": false,
    "maxParticipants": 0,
    "musicGenres": [],
    "hashtags": [
      "Dixieland",
      "JazzParade",
      "Dresden",
      "FestivalWeek",
      "Tonyte",
      "BrassMusic"
    ],
    "tags": [
      "dixieland",
      "jazz-festival",
      "parade",
      "street-music",
      "festival",
      "live-music",
      "brass",
      "outdoor"
    ],
    "visibility": "public",
    "createdAt": "2026-05-01T00:00:00.000Z",
    "createdBy": "system"
  },
  {
    "id": "2026-05-14-katys-garage-thursday-club-night-katy-s-garage-4",
    "title": "Thursday Club Night – Katy's Garage",
    "description": "Katy's Garage is one of those clubs that only Neustadt could produce — unpretentious, slightly chaotic, and reliably good. The Thursday night format rotates through house, funk, and crossover bookings that resist easy categorization. The crowd is a genuine mix: students, locals who've been coming for years, travelers who wandered in from the Alaunstraße and stayed. The space is small enough that you end up talking to everyone and big enough that there's still room to actually dance. Check the door at midnight.",
    "location": "Alaunstraße 48, 01099 Dresden, Germany",
    "address": "Alaunstraße 48, 01099 Dresden, Germany",
    "venueName": "Katy's Garage",
    "city": "Dresden",
    "category": "nightlife",
    "entryType": "official_event",
    "sourceType": "curated_event",
    "hostId": "system",
    "hostName": "Katy's Garage",
    "startDate": "2026-05-14",
    "endDate": "2026-05-14",
    "startTime": "22:00",
    "endTime": "05:00",
    "coordinates": {
      "lat": 51.0689,
      "lng": 13.7396
    },
    "coverImageUrl": "https://tonyte.app/event-images/Rooftop_party_dancing_with_cockt…_202605090203_2.jpeg",
    "coverPhoto": "https://tonyte.app/event-images/Rooftop_party_dancing_with_cockt…_202605090203_2.jpeg",
    "approved": true,
    "isFree": false,
    "maxParticipants": 0,
    "musicGenres": [],
    "hashtags": [
      "KatysGarage",
      "DresdenNightlife",
      "NightOut",
      "Tonyte",
      "Neustadt",
      "DanceFloor"
    ],
    "tags": [
      "house",
      "funk",
      "nightclub",
      "neustadt",
      "social",
      "dancing",
      "underground"
    ],
    "visibility": "public",
    "createdAt": "2026-05-01T00:00:00.000Z",
    "createdBy": "system"
  },
  {
    "id": "2026-05-14-beatpol-atna-album-release-show-5",
    "title": "Ätna – Album Release Show",
    "description": "Berlin electronic pop duo Ätna — Barbe-Noire and PH — bring their new album to Beatpol for one of just four German release shows. Ätna's music occupies a space between precise electronic production and genuinely warm songwriting, and their live performances have a quality that studio recordings can only approximate: the songs breathe differently, the arrangements shift, and the two of them create the kind of intimacy that makes a room feel like it was built specifically for this. Beatpol is a perfect fit — good sound, proper capacity for the room, and a crowd that will have listened to the album before they walk in.",
    "location": "Altbriesnitz 2A, 01169 Dresden, Germany",
    "address": "Altbriesnitz 2A, 01169 Dresden, Germany",
    "venueName": "Beatpol Dresden",
    "city": "Dresden",
    "category": "culture",
    "entryType": "official_event",
    "sourceType": "curated_event",
    "hostId": "system",
    "hostName": "Beatpol Dresden",
    "startDate": "2026-05-14",
    "endDate": "2026-05-14",
    "startTime": "20:00",
    "endTime": "23:00",
    "coordinates": {
      "lat": 51.0366,
      "lng": 13.6878
    },
    "coverImageUrl": "https://tonyte.app/event-images/Candlelight_concert_in_hall_202605090203_2.jpeg",
    "coverPhoto": "https://tonyte.app/event-images/Candlelight_concert_in_hall_202605090203_2.jpeg",
    "approved": true,
    "isFree": false,
    "maxParticipants": 0,
    "musicGenres": [
      "Ätna"
    ],
    "hashtags": [
      "Aetna",
      "AlbumRelease",
      "LiveConcert",
      "Beatpol",
      "Tonyte",
      "IndiePop",
      "ElectronicPop"
    ],
    "tags": [
      "indie-pop",
      "electronic",
      "live-music",
      "album-release",
      "concert",
      "synth-pop"
    ],
    "visibility": "public",
    "createdAt": "2026-05-01T00:00:00.000Z",
    "createdBy": "system"
  },
  {
    "id": "2026-05-15-various-dresden-locations-54-internationales-dixielandfestival-freitag-peak-day-6",
    "title": "54. Internationales Dixielandfestival – Freitag (Peak Day)",
    "description": "Friday is the peak of Dixieland week. Every official stage runs its headline programming, the riverside is packed, and the city operates at a frequency it only reaches a handful of times each year. This is the day for the Elbufer terrace sessions, for wandering between Altstadt and Neustadt and finding something genuinely good around every corner, for staying out later than you intended. If you're only in Dresden for one day of the festival, make it Friday. There is no better introduction to what this city is capable of when it decides to celebrate properly.",
    "location": "Dresden City Center, 01067 Dresden, Germany",
    "address": "Dresden City Center, 01067 Dresden, Germany",
    "venueName": "Various venues across Dresden",
    "city": "Dresden",
    "category": "culture",
    "entryType": "official_event",
    "sourceType": "curated_event",
    "hostId": "system",
    "hostName": "Various venues across Dresden",
    "startDate": "2026-05-15",
    "endDate": "2026-05-15",
    "startTime": "11:00",
    "endTime": "02:00",
    "coordinates": {
      "lat": 51.0504,
      "lng": 13.7381
    },
    "coverImageUrl": "https://tonyte.app/event-images/Festival_stage_with_pyrotechnics_202605090203_2.jpeg",
    "coverPhoto": "https://tonyte.app/event-images/Festival_stage_with_pyrotechnics_202605090203_2.jpeg",
    "approved": true,
    "isFree": false,
    "maxParticipants": 0,
    "musicGenres": [],
    "hashtags": [
      "Dixieland",
      "JazzFestival",
      "DresdenFriday",
      "PeakDay",
      "Tonyte",
      "JazzNight",
      "Elbufer"
    ],
    "tags": [
      "dixieland",
      "jazz-festival",
      "live-music",
      "outdoor",
      "festival",
      "social",
      "riverside",
      "swing"
    ],
    "visibility": "public",
    "createdAt": "2026-05-01T00:00:00.000Z",
    "createdBy": "system"
  },
  {
    "id": "2026-05-15-gare-de-la-lune-la-boum-french-night-at-gare-de-la-lune-7",
    "title": "La Boum – French Night at Gare de la Lune",
    "description": "Gare de la Lune brings its monthly French night back for a Dixieland weekend edition. The concept is simple: French music across eras — ye-yé, chanson, French house, and a generous helping of whatever the DJ feels like playing between the expected moments. The venue is one of Dresden's hidden treasures, a converted space in Blasewitz that manages to feel both glamorous and completely relaxed. Dress however you like. Dance to Gainsbourg. Stay for the part of the night where nobody checks the time anymore.",
    "location": "Pillnitzer Landstraße 148, 01326 Dresden, Germany",
    "address": "Pillnitzer Landstraße 148, 01326 Dresden, Germany",
    "venueName": "Gare de la Lune",
    "city": "Dresden",
    "category": "nightlife",
    "entryType": "official_event",
    "sourceType": "curated_event",
    "hostId": "system",
    "hostName": "Gare de la Lune",
    "startDate": "2026-05-15",
    "endDate": "2026-05-15",
    "startTime": "21:00",
    "endTime": "03:00",
    "coordinates": {
      "lat": 51.0356,
      "lng": 13.8089
    },
    "coverImageUrl": "https://tonyte.app/event-images/Disco_dance_floor_with_mirror_202605090203_3.jpeg",
    "coverPhoto": "https://tonyte.app/event-images/Disco_dance_floor_with_mirror_202605090203_3.jpeg",
    "approved": true,
    "isFree": false,
    "maxParticipants": 0,
    "musicGenres": [],
    "hashtags": [
      "LaBoum",
      "FrenchNight",
      "GareDeLaLune",
      "Tonyte",
      "DresdenNightlife",
      "Chanson"
    ],
    "tags": [
      "french-night",
      "chanson",
      "ye-ye",
      "french-house",
      "social",
      "dancing",
      "nightclub",
      "blasewitz"
    ],
    "visibility": "public",
    "createdAt": "2026-05-01T00:00:00.000Z",
    "createdBy": "system"
  },
  {
    "id": "2026-05-15-objekt-klein-a-objekt-klein-a-freitagnacht-8",
    "title": "objekt klein a – Freitagnacht",
    "description": "objekt klein a does not announce its lineup in advance. It does not have a website with a booking calendar. What it does have is a sound system that costs more than most clubs' annual budgets, a door policy that cares about attitude rather than aesthetics, and a dancefloor that reaches a particular pitch of concentration around 3am that you will not find replicable anywhere else in Saxony. Friday nights in festival week tend to draw people who know exactly what they're looking for. If you're one of them, you already know where this is.",
    "location": "Meschwitzstraße 9, 01099 Dresden, Germany",
    "address": "Meschwitzstraße 9, 01099 Dresden, Germany",
    "venueName": "objekt klein a",
    "city": "Dresden",
    "category": "nightlife",
    "entryType": "official_event",
    "sourceType": "curated_event",
    "hostId": "system",
    "hostName": "objekt klein a",
    "startDate": "2026-05-15",
    "endDate": "2026-05-15",
    "startTime": "23:00",
    "endTime": "08:00",
    "coordinates": {
      "lat": 51.0844,
      "lng": 13.7658
    },
    "coverImageUrl": "https://tonyte.app/event-images/Techno_rave_in_warehouse_club_202605090203_2.jpeg",
    "coverPhoto": "https://tonyte.app/event-images/Techno_rave_in_warehouse_club_202605090203_2.jpeg",
    "approved": true,
    "isFree": false,
    "maxParticipants": 0,
    "musicGenres": [],
    "hashtags": [
      "ObjektKleinA",
      "TechnoNight",
      "UndergroundClub",
      "Tonyte",
      "DresdenTechno",
      "ClubNight"
    ],
    "tags": [
      "techno",
      "electronic",
      "underground",
      "dancefloor",
      "late-night",
      "club"
    ],
    "visibility": "public",
    "createdAt": "2026-05-01T00:00:00.000Z",
    "createdBy": "system"
  },
  {
    "id": "2026-05-15-scheune-dresden-scheune-sommergarten-opening-night-9",
    "title": "Scheune Sommergarten Opening Night",
    "description": "Scheune opens its garden for the season with a proper party: live music in the courtyard, DJs from 22:00, and the kind of mixed crowd that only Neustadt's oldest cultural venue can gather. The Scheune garden is one of Dresden's most beloved outdoor spaces — unpretentious, leafy, and almost certainly full by 20:00 on a Friday in May. Get there early, grab something from the bar, and settle into the evening.",
    "location": "Alaunstraße 36-40, 01099 Dresden, Germany",
    "address": "Alaunstraße 36-40, 01099 Dresden, Germany",
    "venueName": "Scheune Dresden",
    "city": "Dresden",
    "category": "social",
    "entryType": "official_event",
    "sourceType": "curated_event",
    "hostId": "system",
    "hostName": "Scheune Dresden",
    "startDate": "2026-05-15",
    "endDate": "2026-05-15",
    "startTime": "18:00",
    "endTime": "01:00",
    "coordinates": {
      "lat": 51.0669,
      "lng": 13.7415
    },
    "coverImageUrl": "https://tonyte.app/event-images/Music_festival_sunset_diverse_crowd_202605090203_2.jpeg",
    "coverPhoto": "https://tonyte.app/event-images/Music_festival_sunset_diverse_crowd_202605090203_2.jpeg",
    "approved": true,
    "isFree": false,
    "maxParticipants": 0,
    "musicGenres": [],
    "hashtags": [
      "ScheuneGarden",
      "OpeningNight",
      "NeuStadtDresden",
      "Tonyte",
      "SummerVibes",
      "LiveMusic"
    ],
    "tags": [
      "outdoor",
      "garden-party",
      "live-music",
      "social",
      "neustadt",
      "summer",
      "scheune"
    ],
    "visibility": "public",
    "createdAt": "2026-05-01T00:00:00.000Z",
    "createdBy": "system"
  },
  {
    "id": "2026-05-16-various-dresden-locations-54-internationales-dixielandfestival-samstag-grand-finale-10",
    "title": "54. Internationales Dixielandfestival – Samstag (Grand Finale)",
    "description": "Saturday is the grand finale of Dixieland — the day when everything that has been building through the week reaches its resolution. The closing parade, the headline acts on the main stage, the spontaneous collaboration between bands who've spent the week running into each other at every corner. The Elbufer in the evening is as beautiful as Dresden gets: the river catching the last light, the bridges behind you, and jazz coming from four directions at once. It's the kind of evening that makes people book the same week next year before they've even made it home.",
    "location": "Dresden City Center, 01067 Dresden, Germany",
    "address": "Dresden City Center, 01067 Dresden, Germany",
    "venueName": "Various venues across Dresden",
    "city": "Dresden",
    "category": "culture",
    "entryType": "official_event",
    "sourceType": "curated_event",
    "hostId": "system",
    "hostName": "Various venues across Dresden",
    "startDate": "2026-05-16",
    "endDate": "2026-05-16",
    "startTime": "11:00",
    "endTime": "02:00",
    "coordinates": {
      "lat": 51.0504,
      "lng": 13.7381
    },
    "coverImageUrl": "https://tonyte.app/event-images/Festival_stage_with_pyrotechnics_202605090203.jpeg",
    "coverPhoto": "https://tonyte.app/event-images/Festival_stage_with_pyrotechnics_202605090203.jpeg",
    "approved": true,
    "isFree": false,
    "maxParticipants": 0,
    "musicGenres": [],
    "hashtags": [
      "Dixieland",
      "GrandFinale",
      "JazzFestival",
      "Dresden",
      "Tonyte",
      "Elbufer",
      "FestivalFinale"
    ],
    "tags": [
      "dixieland",
      "jazz-festival",
      "live-music",
      "outdoor",
      "festival",
      "finale",
      "parade",
      "swing"
    ],
    "visibility": "public",
    "createdAt": "2026-05-01T00:00:00.000Z",
    "createdBy": "system"
  },
  {
    "id": "2026-05-16-sommerwirtschaft-saloppe-saloppe-sommersonnabend-11",
    "title": "Saloppe – Sommersonnabend",
    "description": "Saloppe's riverside terrace is one of those places that needs very little occasion to justify going — but a Saturday in mid-May with Dixieland sounds drifting across the Elbe is about as good a reason as any. The garden runs from afternoon into the evening, with DJs picking up when the light fades and the view across the river shifts from golden to blue. Food, cocktails, people who came for the atmosphere and stayed for everything else. Saloppe doesn't try to be anything it isn't — it just does its particular thing very well.",
    "location": "Brockhausstraße 1, 01099 Dresden, Germany",
    "address": "Brockhausstraße 1, 01099 Dresden, Germany",
    "venueName": "Sommerwirtschaft Saloppe",
    "city": "Dresden",
    "category": "social",
    "entryType": "official_event",
    "sourceType": "curated_event",
    "hostId": "system",
    "hostName": "Sommerwirtschaft Saloppe",
    "startDate": "2026-05-16",
    "endDate": "2026-05-16",
    "startTime": "14:00",
    "endTime": "23:00",
    "coordinates": {
      "lat": 51.0816,
      "lng": 13.7863
    },
    "coverImageUrl": "https://tonyte.app/event-images/Music_festival_sunset_diverse_crowd_202605090203_3.jpeg",
    "coverPhoto": "https://tonyte.app/event-images/Music_festival_sunset_diverse_crowd_202605090203_3.jpeg",
    "approved": true,
    "isFree": false,
    "maxParticipants": 0,
    "musicGenres": [],
    "hashtags": [
      "Saloppe",
      "SummerDay",
      "RiversideDresden",
      "Tonyte",
      "GartenParty",
      "Elbufer"
    ],
    "tags": [
      "outdoor",
      "riverside",
      "summer",
      "garden-party",
      "social",
      "chill",
      "cocktails",
      "saloppe"
    ],
    "visibility": "public",
    "createdAt": "2026-05-01T00:00:00.000Z",
    "createdBy": "system"
  },
  {
    "id": "2026-05-16-downtown-loft-house-house-philosophy-saturday-edition-12",
    "title": "House Philosophy – Saturday Edition",
    "description": "Downtown Loft House runs its House Philosophy series through the summer, and the Dixieland weekend edition always draws a different crowd than usual — travelers who discovered the city through the festival and are looking for what happens after the stages close, regulars who know that this is where Saturday night actually lives. The format is simple: deep house from 22:00, tech-house from 01:00, no special guests announced in advance. Just a room, a system, and a commitment to keeping the floor moving through breakfast.",
    "location": "Katharinenstraße 11, 01099 Dresden, Germany",
    "address": "Katharinenstraße 11, 01099 Dresden, Germany",
    "venueName": "Downtown Loft House",
    "city": "Dresden",
    "category": "nightlife",
    "entryType": "official_event",
    "sourceType": "curated_event",
    "hostId": "system",
    "hostName": "Downtown Loft House",
    "startDate": "2026-05-16",
    "endDate": "2026-05-16",
    "startTime": "22:00",
    "endTime": "07:00",
    "coordinates": {
      "lat": 51.0666,
      "lng": 13.7492
    },
    "coverImageUrl": "https://tonyte.app/event-images/Disco_dance_floor_with_mirror_202605090203_4.jpeg",
    "coverPhoto": "https://tonyte.app/event-images/Disco_dance_floor_with_mirror_202605090203_4.jpeg",
    "approved": true,
    "isFree": false,
    "maxParticipants": 0,
    "musicGenres": [],
    "hashtags": [
      "HousePhilosophy",
      "DeepHouse",
      "DowntownLoftHouse",
      "Tonyte",
      "DresdenNightlife",
      "ClubNight"
    ],
    "tags": [
      "house",
      "deep-house",
      "tech-house",
      "nightclub",
      "dancefloor",
      "late-night",
      "dresden"
    ],
    "visibility": "public",
    "createdAt": "2026-05-01T00:00:00.000Z",
    "createdBy": "system"
  },
  {
    "id": "2026-05-16-konzertplatz-weisser-hirsch-konzertplatz-wei-er-hirsch-abschlusskonzert-13",
    "title": "Konzertplatz Weißer Hirsch – Abschlusskonzert",
    "description": "The hillside above Dresden hosts its Dixieland closing concert in the open air: a full evening of festival ensemble performances in one of the city's most beautiful outdoor settings. Konzertplatz Weißer Hirsch sits above the city with views across the valley, and on a clear May evening it is hard to imagine a better place to hear jazz. Blankets and bottles recommended. Programme includes headliners from the 54th festival's international roster. Check the festival website for the confirmed lineup.",
    "location": "Stechgrundstraße 2A, 01324 Dresden, Germany",
    "address": "Stechgrundstraße 2A, 01324 Dresden, Germany",
    "venueName": "Konzertplatz Weißer Hirsch",
    "city": "Dresden",
    "category": "culture",
    "entryType": "official_event",
    "sourceType": "curated_event",
    "hostId": "system",
    "hostName": "Konzertplatz Weißer Hirsch",
    "startDate": "2026-05-16",
    "endDate": "2026-05-16",
    "startTime": "19:00",
    "endTime": "23:00",
    "coordinates": {
      "lat": 51.0634,
      "lng": 13.8223
    },
    "coverImageUrl": "https://tonyte.app/event-images/Candlelight_concert_in_hall_202605090203_3.jpeg",
    "coverPhoto": "https://tonyte.app/event-images/Candlelight_concert_in_hall_202605090203_3.jpeg",
    "approved": true,
    "isFree": false,
    "maxParticipants": 0,
    "musicGenres": [],
    "hashtags": [
      "WeisserHirsch",
      "JazzConcert",
      "OutdoorConcert",
      "Tonyte",
      "Dixieland",
      "DresdenView"
    ],
    "tags": [
      "jazz",
      "concert",
      "outdoor",
      "festival",
      "dixieland",
      "swing",
      "ensemble",
      "weisser-hirsch"
    ],
    "visibility": "public",
    "createdAt": "2026-05-01T00:00:00.000Z",
    "createdBy": "system"
  },
  {
    "id": "2026-05-16-stromwerk-dresden-stromwerk-presents-svreca-14",
    "title": "Stromwerk presents: Svreca",
    "description": "Stromwerk brings one of Madrid's most respected techno selectors to the converted power station for a night that will run well past whatever you were planning. Svreca's sets are exercises in patience — slow builds, long arcs, the kind of DJ logic that requires a floor willing to stay and find out where it ends. Stromwerk's industrial architecture is perfectly suited to this: high ceilings, serious acoustics, and a crowd that came specifically for the music. Get there before 01:00 if you want a reasonable position on the floor.",
    "location": "Kraftwerk Mitte 28, 01067 Dresden, Germany",
    "address": "Kraftwerk Mitte 28, 01067 Dresden, Germany",
    "venueName": "Stromwerk Dresden",
    "city": "Dresden",
    "category": "nightlife",
    "entryType": "official_event",
    "sourceType": "curated_event",
    "hostId": "system",
    "hostName": "Stromwerk Dresden",
    "startDate": "2026-05-16",
    "endDate": "2026-05-16",
    "startTime": "23:00",
    "endTime": "09:00",
    "coordinates": {
      "lat": 51.0504,
      "lng": 13.7191
    },
    "coverImageUrl": "https://tonyte.app/event-images/Techno_rave_in_warehouse_club_202605090203_3.jpeg",
    "coverPhoto": "https://tonyte.app/event-images/Techno_rave_in_warehouse_club_202605090203_3.jpeg",
    "approved": true,
    "isFree": false,
    "maxParticipants": 0,
    "musicGenres": [
      "Svreca"
    ],
    "hashtags": [
      "Svreca",
      "TechnoNight",
      "Stromwerk",
      "Tonyte",
      "UndergroundTechno",
      "DresdenTechno"
    ],
    "tags": [
      "techno",
      "underground",
      "dancefloor",
      "electronic",
      "industrial",
      "late-night",
      "club",
      "svreca"
    ],
    "visibility": "public",
    "createdAt": "2026-05-01T00:00:00.000Z",
    "createdBy": "system"
  },
  {
    "id": "2026-05-16-zentralwerk-zentralwerk-kulturfest-tag-der-offenen-tur-15",
    "title": "Zentralwerk Kulturfest – Tag der offenen Tür",
    "description": "Zentralwerk opens its studios, workshops, and courtyards for its annual open day — a chance to explore one of Dresden's most interesting creative communities. Artists in residence show current work, the courtyard runs a programme of live music and performances, and the kitchen serves food until the evening. Zentralwerk is the kind of place that takes culture seriously without making it inaccessible: you'll see contemporary art, theatre rehearsals, and a ceramicist at a wheel all within the same afternoon. Worth the trip to Pieschen.",
    "location": "Riesaer Straße 32, 01127 Dresden, Germany",
    "address": "Riesaer Straße 32, 01127 Dresden, Germany",
    "venueName": "Zentralwerk",
    "city": "Dresden",
    "category": "culture",
    "entryType": "official_event",
    "sourceType": "curated_event",
    "hostId": "system",
    "hostName": "Zentralwerk",
    "startDate": "2026-05-16",
    "endDate": "2026-05-16",
    "startTime": "14:00",
    "endTime": "22:00",
    "coordinates": {
      "lat": 51.0804,
      "lng": 13.7263
    },
    "coverImageUrl": "https://tonyte.app/event-images/Cafe_night_diverse_people_talking_202605090203_3.jpeg",
    "coverPhoto": "https://tonyte.app/event-images/Cafe_night_diverse_people_talking_202605090203_3.jpeg",
    "approved": true,
    "isFree": false,
    "maxParticipants": 0,
    "musicGenres": [],
    "hashtags": [
      "Zentralwerk",
      "TagDerOffenenTuer",
      "DresdenArt",
      "Tonyte",
      "CreativeCommunity",
      "Kultur"
    ],
    "tags": [
      "culture",
      "art",
      "open-day",
      "creative-community",
      "social",
      "live-music",
      "exhibition"
    ],
    "visibility": "public",
    "createdAt": "2026-05-01T00:00:00.000Z",
    "createdBy": "system"
  },
  {
    "id": "2026-05-17-various-dresden-locations-dixieland-aftermath-jazz-brunch-trail-16",
    "title": "Dixieland Aftermath – Jazz Brunch Trail",
    "description": "The morning after Dixieland's grand finale, Dresden is still exhaling. Several Neustadt cafés and bars run informal jazz brunch sessions throughout Sunday morning — smaller ensembles, later-rising crowds, and the particular pleasure of jazz at noon when the city is still coming back to itself. No single official event, but the trail is easy to follow: start at Alaunstraße and follow the sound. Scheune's courtyard, Café Pawlow's terrace, and a handful of other spots run sessions with no announced schedule. The best discoveries will be accidental.",
    "location": "Neustadt, 01099 Dresden, Germany",
    "address": "Neustadt, 01099 Dresden, Germany",
    "venueName": "Neustadt / Altstadt cafés",
    "city": "Dresden",
    "category": "social",
    "entryType": "official_event",
    "sourceType": "curated_event",
    "hostId": "system",
    "hostName": "Neustadt / Altstadt cafés",
    "startDate": "2026-05-17",
    "endDate": "2026-05-17",
    "startTime": "10:00",
    "endTime": "15:00",
    "coordinates": {
      "lat": 51.0669,
      "lng": 13.7415
    },
    "coverImageUrl": "https://tonyte.app/event-images/Cafe_night_diverse_people_talking_202605090203_2.jpeg",
    "coverPhoto": "https://tonyte.app/event-images/Cafe_night_diverse_people_talking_202605090203_2.jpeg",
    "approved": true,
    "isFree": false,
    "maxParticipants": 0,
    "musicGenres": [],
    "hashtags": [
      "JazzBrunch",
      "DresdenSunday",
      "Neustadt",
      "Tonyte",
      "MorningVibes",
      "AfterDixieland"
    ],
    "tags": [
      "jazz",
      "brunch",
      "social",
      "outdoor",
      "chill",
      "neustadt",
      "sunday-morning",
      "street-music"
    ],
    "visibility": "public",
    "createdAt": "2026-05-01T00:00:00.000Z",
    "createdBy": "system"
  },
  {
    "id": "2026-05-17-sommerwirtschaft-saloppe-saloppe-sundowner-after-festival-edition-17",
    "title": "Saloppe Sundowner – After-Festival Edition",
    "description": "Saloppe rounds out the Dixieland weekend with an afternoon-into-evening sundowner on the Elbe terrace. The crowds from the week thin out on Sunday, which is arguably when Saloppe is at its best: fewer people, more room, the same beautiful view and the same gentle pace. A local DJ runs a relaxed set from 17:00, the kitchen serves its full menu, and the whole thing is designed for people who want one more good afternoon before the week resumes. Perfect way to close the loop on a festival-shaped week in Dresden.",
    "location": "Brockhausstraße 1, 01099 Dresden, Germany",
    "address": "Brockhausstraße 1, 01099 Dresden, Germany",
    "venueName": "Sommerwirtschaft Saloppe",
    "city": "Dresden",
    "category": "social",
    "entryType": "official_event",
    "sourceType": "curated_event",
    "hostId": "system",
    "hostName": "Sommerwirtschaft Saloppe",
    "startDate": "2026-05-17",
    "endDate": "2026-05-17",
    "startTime": "15:00",
    "endTime": "22:00",
    "coordinates": {
      "lat": 51.0816,
      "lng": 13.7863
    },
    "coverImageUrl": "https://tonyte.app/event-images/Music_festival_sunset_diverse_crowd_202605090203_4.jpeg",
    "coverPhoto": "https://tonyte.app/event-images/Music_festival_sunset_diverse_crowd_202605090203_4.jpeg",
    "approved": true,
    "isFree": false,
    "maxParticipants": 0,
    "musicGenres": [],
    "hashtags": [
      "Saloppe",
      "Sundowner",
      "AfterFestival",
      "Tonyte",
      "ElbeRiver",
      "DresdenSunday"
    ],
    "tags": [
      "outdoor",
      "sundowner",
      "riverside",
      "social",
      "chill",
      "after-festival",
      "saloppe",
      "elbe"
    ],
    "visibility": "public",
    "createdAt": "2026-05-01T00:00:00.000Z",
    "createdBy": "system"
  },
  {
    "id": "2026-05-17-der-lude-der-lude-sonntagsclub-18",
    "title": "Der Lude – Sonntagsclub",
    "description": "Der Lude's Sunday night sessions exist for people who refuse to let the weekend end at a reasonable hour. The format is fluid — house, funk, soul, and whatever the resident DJs feel is right for the particular mood of the room. Sunday at Lude has its own atmosphere: less frenetic than Friday or Saturday, more focused, people who are there specifically because they want one more good night rather than because they have somewhere to be tomorrow morning. Small venue, warm room, good decisions.",
    "location": "Görlitzer Str. 3, 01099 Dresden, Germany",
    "address": "Görlitzer Str. 3, 01099 Dresden, Germany",
    "venueName": "Der Lude",
    "city": "Dresden",
    "category": "nightlife",
    "entryType": "official_event",
    "sourceType": "curated_event",
    "hostId": "system",
    "hostName": "Der Lude",
    "startDate": "2026-05-17",
    "endDate": "2026-05-17",
    "startTime": "21:00",
    "endTime": "04:00",
    "coordinates": {
      "lat": 51.0659,
      "lng": 13.7596
    },
    "coverImageUrl": "https://tonyte.app/event-images/Rooftop_party_dancing_with_cockt…_202605090203_3.jpeg",
    "coverPhoto": "https://tonyte.app/event-images/Rooftop_party_dancing_with_cockt…_202605090203_3.jpeg",
    "approved": true,
    "isFree": false,
    "maxParticipants": 0,
    "musicGenres": [],
    "hashtags": [
      "DerLude",
      "SundayClub",
      "DresdenNightlife",
      "Tonyte",
      "HouseMusic",
      "Neustadt"
    ],
    "tags": [
      "house",
      "soul",
      "funk",
      "nightclub",
      "sunday",
      "social",
      "dancefloor",
      "neustadt"
    ],
    "visibility": "public",
    "createdAt": "2026-05-01T00:00:00.000Z",
    "createdBy": "system"
  },
  {
    "id": "2026-05-17-club-paula-club-paula-techno-sunday-19",
    "title": "Club Paula – Techno Sunday",
    "description": "Club Paula runs its Sunday techno session through the night for those with the commitment to see a festival weekend through to its logical conclusion. Paula is one of the newer additions to Dresden's club landscape but has found its footing quickly: a focused programme, a crowd that travels to be there, and a commitment to harder, darker techno that distinguishes it clearly from the city's house-oriented venues. Sunday at Paula is a particular experience — the city is quieter outside, which somehow makes the music inside feel more present.",
    "location": "Meschwitzstraße 14, 01099 Dresden, Germany",
    "address": "Meschwitzstraße 14, 01099 Dresden, Germany",
    "venueName": "Club Paula",
    "city": "Dresden",
    "category": "nightlife",
    "entryType": "official_event",
    "sourceType": "curated_event",
    "hostId": "system",
    "hostName": "Club Paula",
    "startDate": "2026-05-17",
    "endDate": "2026-05-17",
    "startTime": "22:00",
    "endTime": "06:00",
    "coordinates": {
      "lat": 51.0844,
      "lng": 13.7659
    },
    "coverImageUrl": "https://tonyte.app/event-images/Techno_rave_in_warehouse_club_202605090203.jpeg",
    "coverPhoto": "https://tonyte.app/event-images/Techno_rave_in_warehouse_club_202605090203.jpeg",
    "approved": true,
    "isFree": false,
    "maxParticipants": 0,
    "musicGenres": [],
    "hashtags": [
      "ClubPaula",
      "TechnoSunday",
      "DresdenTechno",
      "Tonyte",
      "UndergroundClub",
      "DarkTechno"
    ],
    "tags": [
      "techno",
      "dark-techno",
      "underground",
      "dancefloor",
      "late-night",
      "club",
      "industrial"
    ],
    "visibility": "public",
    "createdAt": "2026-05-01T00:00:00.000Z",
    "createdBy": "system"
  },
  {
    "id": "2026-05-17-alter-schlachthof-flea-market-live-music-alter-schlachthof-20",
    "title": "Flea Market & Live Music – Alter Schlachthof",
    "description": "The Alter Schlachthof Sunday flea market is one of the best in the city — sprawling, unpredictable, and always worth the time. Vendors range from serious dealers with crates of vinyl and vintage equipment to neighbours clearing out their attics. The live music programme runs through the afternoon on the outdoor stage: acoustic sets, local bands, and a few Dixieland-adjacent performers wrapping up their festival week with something more informal. Good food stalls, coffee that works, and the particular pleasure of having no fixed plan for several hours.",
    "location": "Gothaer Straße 11, 01097 Dresden, Germany",
    "address": "Gothaer Straße 11, 01097 Dresden, Germany",
    "venueName": "Alter Schlachthof",
    "city": "Dresden",
    "category": "social",
    "entryType": "official_event",
    "sourceType": "curated_event",
    "hostId": "system",
    "hostName": "Alter Schlachthof",
    "startDate": "2026-05-17",
    "endDate": "2026-05-17",
    "startTime": "10:00",
    "endTime": "18:00",
    "coordinates": {
      "lat": 51.0556,
      "lng": 13.7418
    },
    "coverImageUrl": "https://tonyte.app/event-images/International_student_social_party_202605090203_2.jpeg",
    "coverPhoto": "https://tonyte.app/event-images/International_student_social_party_202605090203_2.jpeg",
    "approved": true,
    "isFree": false,
    "maxParticipants": 0,
    "musicGenres": [],
    "hashtags": [
      "AlterSchlachthof",
      "FlohMarkt",
      "SundayMarket",
      "Tonyte",
      "DresdenSunday",
      "LiveAcoustic"
    ],
    "tags": [
      "flea-market",
      "social",
      "outdoor",
      "live-music",
      "acoustic",
      "community",
      "sunday"
    ],
    "visibility": "public",
    "createdAt": "2026-05-01T00:00:00.000Z",
    "createdBy": "system"
  },
  {
    "id": "2026-05-17-objekt-klein-a-objekt-klein-a-closing-night-21",
    "title": "objekt klein a – Closing Night",
    "description": "objekt klein a closes the Dixieland festival weekend with a late-starting, long-running night that quietly establishes itself as the best kept secret of the week. After two weeks of outdoor stages and festival crowds, the club offers something the city has earned: a room where the music is serious, the floor is focused, and the morning arrives before anyone notices. No warm-up, no schedule. Just the continued operation of one of eastern Germany's most singular clubs, running its Sunday into Monday as it sees fit.",
    "location": "Meschwitzstraße 9, 01099 Dresden, Germany",
    "address": "Meschwitzstraße 9, 01099 Dresden, Germany",
    "venueName": "objekt klein a",
    "city": "Dresden",
    "category": "nightlife",
    "entryType": "official_event",
    "sourceType": "curated_event",
    "hostId": "system",
    "hostName": "objekt klein a",
    "startDate": "2026-05-17",
    "endDate": "2026-05-17",
    "startTime": "23:59",
    "endTime": "08:00",
    "coordinates": {
      "lat": 51.0844,
      "lng": 13.7658
    },
    "coverImageUrl": "https://tonyte.app/event-images/Techno_rave_in_warehouse_club_202605090203_2.jpeg",
    "coverPhoto": "https://tonyte.app/event-images/Techno_rave_in_warehouse_club_202605090203_2.jpeg",
    "approved": true,
    "isFree": false,
    "maxParticipants": 0,
    "musicGenres": [],
    "hashtags": [
      "ObjektKleinA",
      "ClosingNight",
      "TechnoNight",
      "Tonyte",
      "UndergroundDresden",
      "AfterHours"
    ],
    "tags": [
      "techno",
      "electronic",
      "underground",
      "late-night",
      "dancefloor",
      "closing-night",
      "club"
    ],
    "visibility": "public",
    "createdAt": "2026-05-01T00:00:00.000Z",
    "createdBy": "system"
  }
];
